module.exports = __webpack_public_path__ + "img/preemie-brochure.cdbfb5bd.png";